import React, { useState } from "react";
import { Grid, Typography, Box } from "@mui/material";
import Drawer from "@mui/material/Drawer";

import ModalClose from "../../../constants/icons/ModalClose";
import JobPreview from "../article/Email/JobPreview";

type Anchor = "right";

interface TemporaryDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  isCloseButton?: boolean;
}

const TemporaryDrawer: React.FC<TemporaryDrawerProps> = ({
  isOpen,
  onClose,
  isCloseButton,
}) => {
  const anchor: Anchor = "right";

  const list = (anchor: Anchor) => (
    <Grid
      role="presentation"
      display="flex"
      flexDirection="column"
      overflow="hidden"
    >
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        sx={{
          padding: "8px 12px",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #D2D1D6",
        }}
      >
        <Typography sx={{ fontSize: "18px", fontWeight: 700 }}>
          Job post preview
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        sx={{ flexGrow: 1, overflowY: "auto" }}
      >
        <JobPreview />
      </Grid>
    </Grid>
  );

  return (
    <Drawer
      anchor={anchor}
      open={isOpen}
      onClose={onClose}
      sx={{ zIndex: 9999999999 }}
      PaperProps={{
        sx: {
          width: "916px",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {isCloseButton && (
        <Box
          className="resume-drawer"
          style={{
            position: "fixed",
            right: "926px",
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <ModalClose onClick={onClose} />
        </Box>
      )}
      {list(anchor)}
    </Drawer>
  );
};

export default TemporaryDrawer;
